import { useState, memo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RedirectContainer, RedirectNavigation, HeaderContainer } from '~src/styles/shared.sc';
import TimeOutButton from '~src/shared/buttons/TimeOutButton';
import { routes } from '~src/routingConfig';
import {
  MainHeader,
  SubHeader,
  NextInfo,
  NextContainer,
  ButtonContainer,
  RedirectContentWrapper,
} from '~src/modules/okrs/objectivesStream/shared.sc';
import ObjectiveProgress from '~src/modules/okrs/objectivesStream/objectiveUpdated/objectiveProgress/ObjectiveProgress';
import { NextObjective } from '~src/modules/okrs/objectivesStream/objectiveUpdated/FinishedObjectiveStream';
import { translateContent } from '~src/services/translationServices';
import { ObjectiveI } from '~src/store/okrs/keyResultStream/interfaces';

interface OwnProps {
  currObjective: ObjectiveI;
  nextObjective: NextObjective;
}

type Props = OwnProps & RouteComponentProps<any>;

const timerCountDown = 10000;
const timeForSlidingIn = 800;
const timeForSlidingOut = 500;

const MoreToUpdate = memo((props: Props) => {
  const [redirect, setRedirect] = useState(false);
  const [t] = useTranslation();

  const handleClick = () => {
    setRedirect(true);
    setTimeout(() => {
      props.history.push(routes.okrs.objectivesStream.updateObjectiveKRs + `/${props.nextObjective.id}`);
    }, timeForSlidingOut);
  };

  return (
    <RedirectContainer>
      {/* height is for aligning to center the next objective
       pane (RedirectNavigation) and the  ObjectiveProgress*/}
      <RedirectContentWrapper $height={'325px'} $redirect={redirect}>
        <ObjectiveProgress
          name={translateContent(props.currObjective.name)}
          progress={props.currObjective.progress}
          blurOnMobile
        />
      </RedirectContentWrapper>
      <RedirectNavigation
        $redirect={redirect}
        $timeForSlidingIn={timeForSlidingIn}
        $timeForSlidingOut={timeForSlidingOut}
      >
        <ButtonContainer hide={redirect}>
          <NextContainer>
            <HeaderContainer>
              <SubHeader>{t('x.okr.update_stream.objective_updated.upcoming_objective')}</SubHeader>
            </HeaderContainer>
            <NextInfo>
              <TimeOutButton
                onClick={handleClick}
                start
                time={timerCountDown}
                finishedCall={handleClick}
                progress={0}
              />
              <div>
                <MainHeader>{translateContent(props.nextObjective.name)}</MainHeader>
                <SubHeader>
                  {t('x.okr.update_stream.update_key_result.remaining_krs', {
                    krNum: props.nextObjective.keyResultsAmount,
                  })}
                </SubHeader>
              </div>
            </NextInfo>
          </NextContainer>
        </ButtonContainer>
      </RedirectNavigation>
    </RedirectContainer>
  );
});

const MoreToUpdateSuper = withRouter(MoreToUpdate);

export default MoreToUpdateSuper;
